module.exports = __webpack_public_path__ + "static/media/customer-pizza.ee0c43a3.png";